import React, { useState, useEffect } from "react";

import './asyncImage.scss';

function AsyncImage({ src, alt }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setLoading(false);
      setImageSrc(src);
    };
    img.onerror = () => {
      setLoading(false);
      setError(true);
    };
    img.src = src;
  }, [src]);

  if (loading) {
    return <div className="imageLoader">
      <div className="imageSpinner"></div>
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA4AAAAPoAQMAAAC1XQIjAAAAA1BMVEX///+nxBvIAAAAkElEQVR42uzBgQAAAACAoP2pF6kCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOD24EAAAAAAQJC/9SBXAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABrAbl3AAHcL6aHAAAAAElFTkSuQmCC" alt="" />
    </div>;
  }

  if (error) {
    return <div>Error loading image</div>;
  }

  return <img src={imageSrc} alt={alt} />;
}

export default AsyncImage;
